import * as Constants from '../constants/';

const initialState = {
  isLoading: false,
  error: null,
  data: {
    import_configuration: {}
  }
};

export default function(state = initialState, action) {
  switch (action.type) {
    case Constants.REQUEST_IMPORT_CONFIGURATION:
      return { ...state, isLoading: true };
    case Constants.RECEIVE_IMPORT_CONFIGURATION:
      if (action.error) {
        return { ...state, isLoading: false, error: action.error };
      }
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          import_configuration: action.data.import_configuration
        }
      };
    case Constants.REQUEST_FTP_IMPORT_CONFIGURATION:
      return { ...state, isLoading: true };
    case Constants.RECEIVE_FTP_IMPORT_CONFIGURATION:
      if (action.error) {
        return { ...state, isLoading: false, error: action.error };
      }
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          import_configuration: action.data.import_configuration
        }
      };
    default:
      return state;
  }
}
